<template>
  <div class="main">
    <el-tabs v-model="tabs_active" type="card" closable @edit="handleTabsEdit">
      <el-tab-pane
        :key="item.name"
        v-for="(item,index) in urls"
        :label="item.name"
        :name="item.name"
      >
        <iframe
          :src="'https://www.sxxskw.com/MyNosql/'+item.url"
          width="100%"
          height="100%"
          frameborder="0"
          scrolling="auto"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template> 
<script>
import { mapActions, mapState,mapGetters} from "vuex";
export default {
  name: "myMain",
  props: ["url"],
  data() {
    return {
      isCollapse: true, 
    };
  },
  methods: {
    ...mapActions(["delUrl"]),
    historyBack() {
      history.back();
    },
    clickRight() {
      this.$emit("click-right", "");
    },
    handleTabsEdit(targetName, action) {
      if (action === "add") {
        /*let newTabName = ++this.tabIndex + '';
          this.editableTabs.push({
            title: 'New Tab',
            name: newTabName,
            content: 'New Tab content'
          });
          this.editableTabsValue = newTabName;*/
      }
      if (action === "remove") { 
        /*let activeName = this.tabs_active;
        if (activeName === targetName) {
          this.urls.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = this.urls[index + 1] || this.urls[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          }); 
         }*/
         this.delUrl(targetName);
        console.log(this.tabs_active)
      }
    }
  },
  computed: {
    ...mapState(["urls", "comhttp"]),
    ...mapGetters(["tabs_active"])
  },
  mounted() {
    //this.editableTabsValue = this.urls[0].name;
    console.log(this.editableTabsValue);
  }
};
</script> 
<style lang="scss">
@import "../assets/basic.scss";
.main {
  height: 100%;
  width: 100%;
  .el-tabs {
    height: 100%;
    .el-tabs__content {
      height: 100%;
    }
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>